<!-- 留学资讯 -->
<template>
  <div class="page flex-col">
    <div class="navbar">
      <my-navbar class="navbarone"></my-navbar>
    </div>
    <!-- 留学资讯 -->
    <div v-show="road">
      <div class="block_red flex-col"></div>
      <div class="section_3 flex-row">
        <div class="main">
          <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb59cce0e73798de2431f26b74202ba9b19d58adc145d502515db964d7c84cd77"
          />
          <span class="text_13 buts" @click="back()">返回首页</span>
          <img
            class="thumbnail_2"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng9cd2a54b44174a86dfcf7cf860a411307073c6418cfbb72587ca1e4acb495fb8"
          />
          <span class="text_14 buts" @click="abroad()">留学资讯</span>
          <!-- <span class="text_131 buts" v-if="tb_uuid != ''" @click="details()"
            >资讯详情</span
          > -->
        </div>
      </div>
      <div class="main">
        <div class="section_4 flex-row justify-between">
          <div class="block_1 flex-col justify-between">
            <div
              class="block_2 flex-row justify-between buts"
              @click="getzxxq(detailsdist.tb_uuid)"
            >
              <div class="group_8 flex-col">
                <img 
                    style="
                    height: 100%;
                    /* overflow: hidden;
                    white-space: normal;
                    text-overflow: ellipsis; */
                  "
                :src="'api' + detailsdist.tb_home_img"
                    />
              </div>
              <div class="group_9 flex-col">
                <div
                  style="
                    height: 82%;
                    overflow: hidden;
                    white-space: normal;
                    text-overflow: ellipsis;
                  "
                >
                  <span class="text_15">{{ detailsdist.tb_title }}</span>
                  <span
                    class="paragraph_1"
                    v-html="detailsdist.tb_content"
                  ></span>
                </div>
                <div class="box_1 flex-row justify-between">
                  <div class="image-text_1 flex-row justify-between">
                    <img
                      class="thumbnail_3"
                      referrerpolicy="no-referrer"
                      src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng04453c040779e5492216dc4c60b70da1966c90d620fcea88be9ab2604832e5a5"
                    />
                    <span class="text-group_1"
                      >发布时间：{{
                        detailsdist.tb_exit_time == null
                          ? "1"
                          : detailsdist.tb_exit_time.split("T")[0]
                      }}&nbsp;{{
                        detailsdist.tb_exit_time == null
                          ? "1"
                          : detailsdist.tb_exit_time.split("T")[1]
                      }}</span
                    >
                  </div>
                  <div class="image-text_2 flex-row justify-between">
                    <span class="text-group_2 buts">查看</span>
                    <img
                      class="thumbnail_4"
                      referrerpolicy="no-referrer"
                      src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng97c249608266b644f91e15e013521a8db107e30a67a78ac90c7689ac7d563fc7"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="block_3 flex-row justify-between">
              <div class="group_10 flex-row">
                <div class="image-text_3 flex-row justify-between">
                  <img
                    class="label_1"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng85bcf62f52cf9c8b167cc0766a820ecdb11a0a67e685b7720d8f4401550a3564"
                  />
                  <span class="text-group_3">留学资讯</span>
                </div>
                <div class="group_11 flex-col"></div>
              </div>
              <span class="text_16">留学情報です</span>
            </div>
            <div
              v-for="(item, index) in detailsList"
              :key="index"
              class="image-text_4 flex-row justify-between buts"
              @click="getzxxq(item.tb_uuid)"
            >
              <div class="box_2 flex-row">
                <div class="text-group_4 flex-col justify-between">
                  <span class="text_17">{{
                    item.tb_exit_time.split("-")[2].split("T")[0]
                  }}</span>
                  <span class="text_18">{{
                    item.tb_exit_time.split("-")[0] +
                      "-" +
                      item.tb_exit_time.split("-")[1]
                  }}</span>
                </div>
                <!-- <div class="text-group_5 flex-col justify-between">
                  <span class="text_17">07</span>
                  <span class="text_18">2023-07</span>
                </div> -->
              </div>
              <div class="text-group_6 flex-col justify-between">
                <span class="text_19">{{ item.tb_title }}</span>
                <!-- <span class="text_20">{{item.tb_content}}</span> -->
                <span class="text_20" v-html="item.tb_content"></span>
              </div>
            </div>

            <div class="block_4 flex-col"></div>
            <div class="section_10 flex-row">
              <!-- <span class="text_53">上一页</span>
              <div class="text-wrapper_20 flex-col">
                <span class="text_54">1</span>
              </div>
              <span class="text_55">2</span> <span class="text_56">3</span>
              <span class="text_57">4</span> <span class="text_58">5</span>
              <span class="text_59">下一页</span> -->
              <el-pagination
                background
                layout="prev, pager, next"
                limit="8"
                :total="count"
                :prev-text="'上一页'"
                :next-text="'下一页'"
              >
              </el-pagination>
            </div>
          </div>
          <div class="block_5 flex-col">
            <div class="box_3 flex-row justify-between">
              <div class="group_12 flex-col"></div>
              <span class="text_21">热门标签</span>
              <div class="group_13 flex-col"></div>
            </div>
            <span class="text_22">人気タグ</span>
            <div class="grid_1 flex-row">
              <div
                class="text-wrapper_7 flex-col buts"
                v-for="(item, index) in rm_tegList"
                :key="index"
                @click="address"
              >
                <span class="text_23">{{ item.tb_hxts_name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 资讯详情 -->
    <div v-show="tail">
      <div class="block_red flex-col"></div>
      <div class="tailblock_3 flex-row">
        <div class="main">
          <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb59cce0e73798de2431f26b74202ba9b19d58adc145d502515db964d7c84cd77"
          />
          <span class="text_13 buts" @click="back()">返回首页</span>
          <img
            class="thumbnail_2"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng9cd2a54b44174a86dfcf7cf860a411307073c6418cfbb72587ca1e4acb495fb8"
          />
          <span class="text_14 buts" @click="abroad()">留学资讯</span>
          <img
            class="thumbnail_2"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng9cd2a54b44174a86dfcf7cf860a411307073c6418cfbb72587ca1e4acb495fb8"
          />
          <span class="text_14 buts" @click="details()">资讯详情</span>
        </div>
      </div>
      <div class="main">
        <div class="wenben">
          <div class="tailtext_16">
            {{ detailsdist.tb_title }}
          </div>
          <div class="tailblock_4 flex-row">
            <img
              class="tailthumbnail_4"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngbe63dcce60301e7bfe878336e5060d8a0dda0aa2615db93e3f6b0575d5f4a7d8"
            />
            <span class="tailtext_17">浏览人数：{{ browse }}</span>
            <img
              class="tailthumbnail_5"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng04453c040779e5492216dc4c60b70da1966c90d620fcea88be9ab2604832e5a5"
            />
            <span class="tailtext_18"
              >发布时间：{{
                (detailsdist.tb_exit_time || "").split("T")[0]
              }}</span
            >
          </div>
          <div class="tailblock_8 flex-col justify-between">
            <div class="tailgroup_1 flex-col"></div>
            <!-- <div class="tailtext-wrapper_7 flex-row justify-between">
                <span class="tailtext_20"  v-if="up_page_date" @click="getzxxq(up_page_date.tb_uuid)">&lt;上一条：{{up_page_date.tb_title}}</span>
                <span class="tailtext_21"  v-if="next_page_date" @click="getzxxq(next_page_date.tb_uuid)">下一条: {{next_page_date.tb_title}}&gt;</span>
              </div> -->
          </div>
          <div class="tailblock_5 flex-col"></div>
          <span
            class="tailparagraph_1 flex-col"
            v-html="detailsdist.tb_content"
          >
          </span>
          <!-- <div class="tailblock_6 flex-row justify-between">
            <div class="tailbox_7 flex-col">
              <img
                :src="'api' + detailsdist.tb_home_img"
                style="width: 700px; height: 300px"
                alt=""
              />
            </div>
          </div> -->
          <div class="tailblock_7 flex-row justify-between"></div>
        </div>
      </div>
    </div>
    <!-- <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="100%"
      :before-close="handleClose">
      <video :src='videoSrc' controls='controls' autoplay>
        您的浏览器不支持 video 标签。
      </video>
    </el-dialog> -->
    <my_article></my_article>
    <div class="group_54 flex-col">
      <my-footer class="navbarone"></my-footer>
    </div>
  </div>
</template>

<script>
import navbar from "../components/navbar/navbar.vue";
import footer from "../components/footer/footer.vue";
import article from "../components/article/article.vue";
import { GetWenzhangone } from "../api/wenzhangone";
import { GetWenzhang } from "../api/wenzhang";
import { GetRmteg } from "../api/rm-teg";
export default {
  components: {
    "my-navbar": navbar,
    "my-footer": footer,
    my_article: article
  },
  data() {
    return {
      road: true,
      tail: false,
      detailsList: [], //资讯数据
      rm_tegList: [], //获取热门标签
      detailsdist: {},
      tb_uuid: "", //首页过来的文章ID
      browse: "", //浏览人数
      tb_sign: "1", //1表示查询咨询文章列表   2 表示查询攻略文章列表
      limit: "8", //一页显示条数
      page: "1", //当前页
      count: 0, //总数
      up_page_date: {},
      next_page_date: {}
    };
  },
  created() {
    //首页资讯ID
    if (this.$route.query.tb_uuid != null) {
      this.tb_uuid = this.$route.query.tb_uuid;
      this.tail = true;
      this.road = false;
      this.getzxxq(this.tb_uuid);
    } else {
      this.tb_uuid = "";
    }
    this.getList();
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      document.onselectstart = new Function("event.returnValue=false");
    });
  },
  methods: {
    //返回首页
    back() {
      this.$router.push("page/index");
    },
    //留学咨询
    abroad() {
      this.road = true;
      this.tail = false;
      this.tb_uuid = "";
    },
    //资讯详情
    details() {
      this.road = false;
      this.tail = true;
    },
    //浏览器不支持video提示
    handleClose(done) {
      done();
    },
    // 获取资讯详情
    getzxxq(uuid) {
      document.documentElement.scrollTop = 0;
      this.tb_uuid = uuid;
      GetWenzhangone({ tb_uuid: this.tb_uuid }).then(response => {
        if (response.code == 20000) {
          this.road = false;
          this.tail = true;
          this.detailsdist = response.data.date;
          this.browse = response.data.info_number;
          this.up_page_date = response.data.up_page_data;
          this.next_page_date = response.data.next_page_data;
          console.log(this.up_page_date, this.next_page_date);
        }
      });
    },
    //资讯数据
    getList() {
      GetWenzhang({
        tb_sign: "1",
        limit: this.limit,
        page: this.page
      }).then(response => {
        this.detailsList = response.data.date;
        this.count = response.data.count;
        if (this.road) {
          this.detailsdist = response.data.date[0];
          console.log(response.data, "留学攻略列表");
        }
      });
      GetRmteg().then(response => {
        this.rm_tegList = response.data;
      });
    },
    address() {
      this.$router.push({
        name: "schoolCommon",
        query: {
          teg_key: "特色"
        }
      });
    }
  }
};
</script>
<style src="../../static/css/consult.css" scoped />

<style scoped>
.article {
  display: flex;
  justify-content: center;
}

.link {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/page/consult.vue